import {useMutation} from "@tanstack/react-query";
import {createUserType} from "../services/UserTypeService";

export function useUserTypeCreate() {
    return useMutation({
        mutationFn: createUserType,
    });
}
